<div class="quizTest container">
	<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
	  <symbol id="bi-volume-down-fill" viewBox="0 0 16 16">
	    <path d="M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12V4zm3.025 4a4.486 4.486 0 0 1-1.318 3.182L10 10.475A3.489 3.489 0 0 0 11.025 8 3.49 3.49 0 0 0 10 5.525l.707-.707A4.486 4.486 0 0 1 12.025 8z"/>
	  </symbol>
	  <symbol id="bi-mic-fill" viewBox="0 0 16 16">
	    <path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z"/>
	    <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"/>
	  </symbol>
	</svg>
	<!-- <svg class="" width="16" height="16"><use xlink:href="#volume-down-fill"/></svg> -->
	
	<div class=" container-quiz-category" *ngIf="!btnRetry">
		<div class="quiz-category-left">
			<div id="carouselCategory" class="carousel">
				<div class="carousel-inner">
					<div class="carousel-item"
						*ngFor="let item of biletcategory | paginate: { itemsPerPage: 1, currentPage: page }; let i = index"
						[ngClass]="{ active: i === 0 }">
						<p>{{item.category}}</p>
						<span>{{item.info}}</span>
						<div class="content-left">
							<img class="imgKeyword" [src]="item.url" />
							<div>
								<div class="number-keyword"> Tổng số từ - cụm từ: {{numberOfKeyword}}</div>
								<div class="total-correct">Tổng số câu đúng: {{totalCorrect}}/20</div>
								<div class="">Câu số: {{indexQuizItem}}</div>
								<button (click)="startQuiz()" [class.selected]="btnStartActive" class="btnStart">
									Bắt đầu
								</button>
							</div>
						</div>
					</div>
				</div>
				<pagination-controls (pageChange)="pageChanged($event)" previousLabel="" nextLabel="">
				</pagination-controls>
			</div>
		</div>
		<div class="quiz-category-right">
			<div class="quiz-category">
				<div class="level-zero" *ngIf="quizItem.level===0">
					<div class="question">
						<div class="titleSelect">Chọn đáp án đúng</div>
						<b>{{quizItem.question.text_en}}</b>
					</div>
					<ul>
						<li *ngFor="let it of quizItem.answer" (click)="chooseAnswer(0,it,$event)">
							<img class="imgKeyword" [src]="it.urlKeyword" />
							<p>{{it.keyword_vn}}</p>
						</li>
					</ul>
					<div class="btnResultCheck" [ngClass]="{
				'background-success':resultLevel0 === 1,
				'background-default':resultLevel0 === 0,
				'background-danger':resultLevel0 === 2
			  }">
						<div *ngIf="resultLevel0===1" class="color-success"> Chính xác </div>
						<div *ngIf="resultLevel0===2" class="color-danger">
							<span>Chưa chính xác!</span>
							<div>Đáp án đúng là: {{answerCorrect}}</div>
						</div>
						<button type="button" class="btn btn-success btnCheck" (click)="btnCheck(0)"
							*ngIf="checkOrNextLevel0===0">KIỂM
							TRA</button>
						<button type="button" class="btn btn-success btnCheck" (click)="btnCheck(0)"
							*ngIf="checkOrNextLevel0===1">TIẾP
							TỤC</button>
					</div>

				</div>
				<div class="level-one" *ngIf="quizItem.level===1">
					<div class="question">
						<div class="titleSelect">Chọn đáp án đúng</div>
						<img class="imgKeyword" [src]="quizItem.question.urlKeyword" />
						<b>{{quizItem.question.text_vn}}</b>
					</div>
					<ul>
						<li *ngFor="let item of quizItem.answer">
							<input type="radio" name="item.keyword_en" value="{{item.keyword_en}}"
								(change)="onRadioChange(item)" />
							{{item.keyword_en}}
						</li>
					</ul>
					<div class="btnResultCheck" [ngClass]="{
				'background-success':resultLevel1 === 1,
				'background-default':resultLevel1 === 0,
				'background-danger':resultLevel1 === 2
			  }">
						<div *ngIf="resultLevel1===1" class="color-success"> Chính xác </div>
						<div *ngIf="resultLevel1===2" class="color-danger">
							<span>Chưa chính xác!</span>
							<div>Đáp án đúng là: {{answerCorrect}}</div>
						</div>
						<button type="button" class="btn btn-success btnCheck" (click)="btnCheck(1)"
							*ngIf="checkOrNextLevel1===0">KIỂM TRA</button>
						<button type="button" class="btn btn-success btnCheck" (click)="btnCheck(1)"
							*ngIf="checkOrNextLevel1===1">TIẾP TỤC</button>
					</div>
				</div>

				<!-- <div class="level-two" *ngIf="quizItem.level===2">
					<div class="question">
						<div class="titleSelect">Chọn đáp án đúng</div>
						<i class="fas fa-volume-down icon-head volume-icon" (click)="onClickVolumeIcon()"></i>
						<b>{{quizItem.question.text_vn}}</b>
						<input id="txtAnswerLevel2" class="txtAnswerLevel2" type="text" name="answer" autocomplete="off"
							placeholder="Enter the correct answer">
					</div>
					<div class="btnResultCheck" [ngClass]="{
				'background-success':resultLevel2 === 1,
				'background-default':resultLevel2 === 0,
				'background-danger':resultLevel2 === 2
			  }">
						<div *ngIf="resultLevel2===1" class="color-success"> Chính xác </div>
						<div *ngIf="resultLevel2===2" class="color-danger">
							<span>Chưa chính xác!</span>
							<div>Đáp án đúng là: {{answerCorrect}}</div>
						</div>
						<button type="button" class="btn btn-success btnCheck" (click)="btnCheck(2)"
							*ngIf="checkOrNextLevel2===0">KIỂM TRA</button>
						<button type="button" class="btn btn-success btnCheck" (click)="btnCheck(2)"
							*ngIf="checkOrNextLevel2===1">TIẾP TỤC</button>
					</div>
				</div> -->
				<div class="level-three" *ngIf="quizItem.level===3">
					<div class="question">
						<div class="titleSelect">Nghe và chọn đáp án đúng</div>
						<!-- <i class="fas fa-volume-down icon-head volume-icon"></i> -->
						<svg class="bi-button-round"><use xlink:href="#bi-volume-down-fill" (click)="onClickVolumeIcon()"/></svg>
					</div>
					<ul>
						<li *ngFor="let it of quizItem.answer" (click)="chooseAnswer(3,it,$event)">
							<img class="imgKeyword" [src]="it.urlKeyword" />
							<p>{{it.keyword_vn}}</p>
						</li>
					</ul>
					<div class="btnResultCheck" [ngClass]="{
				'background-success':resultLevel3 === 1,
				'background-default':resultLevel3 === 0,
				'background-danger':resultLevel3 === 2
			  }">
						<div *ngIf="resultLevel3===1" class="color-success"> Chính xác </div>
						<div *ngIf="resultLevel3===2" class="color-danger">
							<span>Chưa chính xác!</span>
							<div>Đáp án đúng là: {{answerCorrect}}</div>
						</div>
						<button type="button" class="btn btn-success btnCheck" (click)="btnCheck(3)"
							*ngIf="checkOrNextLevel3===0">KIỂM
							TRA</button>
						<button type="button" class="btn btn-success btnCheck" (click)="btnCheck(3)"
							*ngIf="checkOrNextLevel3===1">TIẾP
							TỤC</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="btnRetry" class="retry">
		<div class="completed-quiz" *ngIf="completedQuiz">
			<h1>Bạn đã hoàn thành tốt bài học. Mời bạn tiếp tục!</h1>
			<button type="button" class="btn btn-success btnCheck" (click)="retryQuestion()">RETRY</button>
		</div>
		<div class="not-completed" *ngIf="!completedQuiz">
			<h1>Uhm! Kết quả chưa được tốt lắm! Hãy thử lại</h1>
			<button type="button" class="btn btn-success btnCheck" (click)="retryQuestion()">RETRY</button>
		</div>
	</div>
</div>
